<template>
  <el-container class="home-container">
    <!-- 头部区域 -->
    <el-header>
      <Header></Header>
    </el-header>
    <!-- 页面主体区域-->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside
        :width="isCollapse ? '64px' : '200px'"
        :collapse-transition="true"
      >
        <!-- 折叠与展开 -->
        <div class="toggle-button" @click="toggle">|||</div>
        <el-menu
          background-color="#333744"
          text-color="#fff"
          active-text-color="#409EFF"
          :unique-opened="true"
          :collapse="isCollapse"
          :collapse-transition="false"
          :router="true"
          :default-active="activePath"
        >
          <!-- 这是一级菜单 -->
          <el-submenu
            v-for="item in menulist"
            :index="item.id + ''"
            :key="item.id"
          >
            <!-- 一级菜单的模板区域 -->
            <template slot="title">
              <!-- 图标 -->
              <i :class="iconObj[item.id]"></i>
              <!-- 文本 -->
              <span>{{ item.authName }}</span>
            </template>
            <!-- 二级菜单 -->
            <el-menu-item
              :index="'/' + subItem.path"
              v-for="subItem in item.children"
              :key="subItem.id"
              @click="saveNavState('/' + subItem.path)"
            >
              <template slot="title">
                <!-- 图标 -->
                <i :class="iconObj[subItem.id]"></i>
                <!-- 文本 -->
                <span>{{ subItem.authName }}</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!-- 右侧主体区域 -->
      <el-main>
        <!-- 子路由导航 -->
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Header from './common/header/Header';
export default {
  name: 'home',
  components: {
    Header
  },
  data() {
    return {
      // 左侧菜单数据
      menulist: [
        {
          authName: '官网管理',
          id: 100,
          order: 3,
          path: 'home/pc',
          children: [
            {
              authName: '官网前端',
              id: 101,
              order: 11,
              path: 'home/pc/index'
            },
            {
              authName: '课程体系',
              id: 102,
              order: 12,
              path: 'home/pc/course'
            },
            {
              authName: '教务管理',
              id: 103,
              order: 7,
              path: 'home/pc/education'
            }
          ]
        },
        {
          authName: 'OJ管理',
          id: 200,
          order: 1,
          path: 'home/oj',
          children: [
            {
              authName: '权限管理',
              id: 201,
              order: 13,
              path: 'home/oj/permissions'
            },
            {
              authName: '公告管理',
              id: 202,
              order: 11,
              path: 'home/oj/notice'
            },
            {
              authName: '题目管理',
              id: 203,
              order: 12,
              path: 'home/oj/subject',
              children: [
                {
                  authName: '上线题目',
                  id: 501,
                  order: 12_1,
                  path: 'home/oj/subject/online_question'
                },
                {
                  authName: '下线题目',
                  id: 502,
                  order: 12_2,
                  path: 'home/oj/subject/offline_question'
                },
                {
                  authName: '题目类别',
                  id: 503,
                  order: 12_3,
                  path: 'home/oj/subject/question_category'
                }
              ]
            },
            {
              authName: '标签管理',
              id: 204,
              order: 14,
              path: 'home/oj/fication'
            },
            {
              authName: '竞赛管理',
              id: 205,
              order: 13,
              path: 'home/oj/match'
            },
            {
              authName: '题单管理',
              id: 206,
              order: 15,
              path: 'home/oj/quesList'
            }
          ]
        }
      ],
      // 定义图标
      iconObj: {
        100: 'iconfont icon-project-fill', // oj管理
        200: 'iconfont icon-pc-f', //官网管理

        101: 'iconfont icon-pcduan', // 官网前端
        102: 'iconfont icon-jiaowuzhongxin2x', // 课程体系
        103: 'iconfont icon-jiaoxueyunying', //教务管理

        201: 'iconfont icon-guanliyuan1', //权限
        202: 'iconfont icon-gonggao1', // 公告
        203: 'iconfont icon-jiaoxuezhongxinfill', //题目管理
        204: 'iconfont icon-biaoqiantixi1', // 标签管理
        205: 'iconfont icon-bhjsaishi', // 赛事管理
        206: 'iconfont icon-project-fill' // 题单管理
      },
      // 是否折叠
      isCollapse: false,
      // 保存激活链接
      activePath: '',
      squareUrl: '../assets/headers.gif'
    };
  },

  mounted() {
    this.activePath = window.sessionStorage.getItem('activeItem') || '';
  },
  methods: {
    // 控制折叠功能
    toggle() {
      this.isCollapse = !this.isCollapse;
    },
    // 保存被激活的二级菜单链接地址
    saveNavState(activePath) {
      window.sessionStorage.setItem('activeItem', activePath);
      this.activePath = activePath;
    }
  }
};
</script>


<style scoped>
.home-container {
  height: 100%;
}

.el-header{
  padding: 0;
}
/* .el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;
}

.el-header div {
  display: flex;
  align-items: center;
}

.el-header div span {
  margin-left: 15px;
} */

/* 解决aside收起卡顿的问题 */
.el-aside {
  background-color: #333744;
  transition: width 0.15s;
  -webkit-transition: width 0.15s;
  -moz-transition: width 0.15s;
  -o-transition: width 0.15s;
}
/* 加侧边栏文字消失的速度 */
.el-menu {
  transition: all 10ms;
}
.el-aside .el-menu {
  border-right: 0;
}
.el-main {
  background-color: #cedae9;
}
.iconfont {
  margin-right: 10px;
}
.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>